import React, { useRef, useState } from "react";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

import useStyles from "./styles";

interface IProps {
  label: string;
  onChange: (newValue?: boolean) => void;
  selectedValue?: boolean;
}

const MatchTypeSelector = (props: IProps) => {
  const { onChange, label, selectedValue } = props;
  const classes = useStyles();
  const [matchTypeOpen, setMatchTypeOpen] = useState<boolean>(false);
  const matchTypeMenuButtonRef = useRef<HTMLButtonElement>();

  const handleMatchTypeMenuClick = () => {
    setMatchTypeOpen(true);
  };

  const handleMatchTypeMenuClose = () => {
    setMatchTypeOpen(false);
  };

  const handleMatchTypeSelect =
    (areLastRacePreferredConditions?: boolean) => () => {
      onChange(areLastRacePreferredConditions);
      handleMatchTypeMenuClose();
    };

  return (
    <div className={classes.root}>
      <div className={classes.title}>Match Type:</div>
      <Button
        ref={matchTypeMenuButtonRef}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleMatchTypeMenuClick}
        className={clsx(classes.button, {
          [classes.allTypesSelected]: selectedValue === undefined,
          [classes.lastRaceSelected]: selectedValue === true,
          [classes.customSelected]: selectedValue === false
        })}
        classes={{
          endIcon: classes.buttonEndIcon
        }}
        endIcon={
          matchTypeOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />
        }
      >
        {label}
      </Button>
      <Popper
        open={matchTypeOpen}
        anchorEl={matchTypeMenuButtonRef?.current}
        transition
        disablePortal
        placement={"bottom-start"}
        className={classes.popper}
      >
        {({ TransitionProps, placement }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleMatchTypeMenuClose}>
                <MenuList className={classes.list}>
                  <MenuItem
                    className={clsx(classes.item, {
                      [classes.allTypesSelected]: selectedValue === undefined
                    })}
                    onClick={handleMatchTypeSelect(undefined)}
                  >
                    All Types
                  </MenuItem>
                  <MenuItem
                    className={clsx(classes.item, {
                      [classes.lastRaceSelected]: selectedValue === true
                    })}
                    onClick={handleMatchTypeSelect(true)}
                  >
                    Last Race
                  </MenuItem>
                  <MenuItem
                    className={clsx(classes.item, {
                      [classes.customSelected]: selectedValue === false
                    })}
                    onClick={handleMatchTypeSelect(false)}
                  >
                    Custom
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default MatchTypeSelector;
